import { ClientSociety } from "@dune/types";
import { Button, Input } from "@dune/ui";
import { ArrowLeft } from "@untitled-ui/icons-react";
import { useFormContext } from "react-hook-form";
import NewSyndicForm from "./NewSyndicForm";
import { defaultClientSocietyValues } from "@dune/vars";

type SyndicDetailsContainerProps = {
	syndic: ClientSociety | null;
	setSelectedSyndic: (syndic: ClientSociety | undefined) => void;
};

const SyndicDetailsContainer = ({
	syndic,
	setSelectedSyndic,
}: SyndicDetailsContainerProps) => {
	const { setValue } = useFormContext();

	return (
		<div className="flex flex-col gap-4 w-[70%] order-solid border-1 border-gray-200 rounded-lg p-4 self-center">
			<Button
				className="self-start text-[#144C65] text-xl"
				variant="link"
				onClick={() => {
					setSelectedSyndic(undefined);
					setValue("syndicSocietyId", undefined);
					setValue("syndicSociety", {
						...defaultClientSocietyValues,
						isSyndic: true,
					});
				}}
			>
				<ArrowLeft /> Sélectionner un autre syndic
			</Button>
			{syndic === null ? (
				<NewSyndicForm />
			) : (
				<div className="flex flex-col border-solid border-1 border-gray-200 rounded-lg p-4 gap-4">
					<Input value={syndic.siren ?? ""} label="SIREN/SIRET" disabled />
					<Input value={syndic.denomination} label="Raison sociale" disabled />
				</div>
			)}
		</div>
	);
};

export default SyndicDetailsContainer;
